import React from "react";
import { PathRouteProps } from "react-router-dom";
import { routeConstants } from "@/shared/constants";
import Login from "./index";

const RouteDetailRoute: PathRouteProps = {
  path: routeConstants["login"].route,
  element: React.createElement(Login),
};

export default RouteDetailRoute;